import { useEffect, useState } from 'react';

// Zentrale Mobile/Desktop-Grenze der CRM-App: 768px (Tailwind `md`). Wird von
// Komponenten genutzt, die Desktop- und Mobile-Variante in EINER Komponente
// halten (Modal vs. BottomSheet) statt ueber getrennte Seiten — z.B.
// DocumentDetailDialog und FilterDrawer.
//
// SSR-sicher: Der Initial-Wert wird nur im Browser aus matchMedia gelesen,
// auf dem Server faellt er auf `false` (Mobile) zurueck; der Effect
// synchronisiert nach dem Hydrate.
const DESKTOP_QUERY = '(min-width: 768px)';

export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== 'undefined'
      ? window.matchMedia(DESKTOP_QUERY).matches
      : false,
  );
  useEffect(() => {
    const mql = window.matchMedia(DESKTOP_QUERY);
    setIsDesktop(mql.matches);
    const onChange = (e: MediaQueryListEvent) => setIsDesktop(e.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);
  return isDesktop;
}
